var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalcoloRata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4513",
    "data-name": "Raggruppa 4513",
    transform: "translate(29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-calculator-7194245",
    transform: "translate(-38.788 -9.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9561",
    "data-name": "Tracciato 9561",
    d: "M17.21,47h3.268a1.3,1.3,0,0,1,1.21,1.21v1.2a1.209,1.209,0,0,1-1.21,1.21H17.21A1.3,1.3,0,0,1,16,49.409v-1.2A1.209,1.209,0,0,1,17.21,47Z",
    transform: "translate(-0.001 -22.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9562",
    "data-name": "Tracciato 9562",
    d: "M30.185,16H19.392A3.39,3.39,0,0,0,16,19.392v2.378a1.212,1.212,0,0,0,1.21,1.21H32.367a1.212,1.212,0,0,0,1.21-1.21V19.392A3.39,3.39,0,0,0,30.185,16Z",
    transform: "translate(-0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9563",
    "data-name": "Tracciato 9563",
    d: "M43.21,65h2.233a1.3,1.3,0,0,1,1.21,1.21V68.7a1.209,1.209,0,0,1-1.21,1.21H43.21A1.3,1.3,0,0,1,42,68.7V66.21A1.209,1.209,0,0,1,43.21,65Z",
    transform: "translate(-19.28 -36.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9564",
    "data-name": "Tracciato 9564",
    d: "M64,48.21v7.145a1.212,1.212,0,0,0,1.21,1.21h.568a3.39,3.39,0,0,0,3.392-3.392V47H65.21A1.212,1.212,0,0,0,64,48.21Z",
    transform: "translate(-35.593 -22.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9565",
    "data-name": "Tracciato 9565",
    d: "M43.21,47h2.233a1.3,1.3,0,0,1,1.21,1.21v1.2a1.209,1.209,0,0,1-1.21,1.21H43.21A1.3,1.3,0,0,1,42,49.409v-1.2A1.209,1.209,0,0,1,43.21,47Z",
    transform: "translate(-19.28 -22.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9566",
    "data-name": "Tracciato 9566",
    d: "M20.476,65H17.209A1.212,1.212,0,0,0,16,66.21v.31a3.39,3.39,0,0,0,3.392,3.392h1.085a1.212,1.212,0,0,0,1.21-1.21V66.21A1.212,1.212,0,0,0,20.476,65Z",
    transform: "translate(0 -36.334)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcoloRata);
export default __webpack_public_path__ + "static/media/CalcoloRata.322e1b062044bd4bbcdf53f4b1621131.svg";
export { ForwardRef as ReactComponent };